var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selection-indicator",class:{ active: _vm.hasSelection }},[(_vm.hasSelection)?_c('span',{staticClass:"count"},[_vm._v(" "+_vm._s(_vm.selected)+" ")]):_vm._e(),_c('div',{staticClass:"selection-visualizer",style:({ height: _vm.height })})])
}
var staticRenderFns = []

export { render, staticRenderFns }